/**
 * © 2026 Madar.iq — جميع الحقوق محفوظة
 * هذا الملف جزء من منظومة Madar.iq البرمجية.
 * يُحظر نسخه أو تعديله أو توزيعه دون إذن كتابي.
 * All Rights Reserved — Unauthorized use is prohibited.
 */
import { useTranslation } from "react-i18next";
import logoArabic from "../../../assets/logoArabic.png";
import logoEnglish from "../../../assets/logoEnglish.png";
import { COLORS } from "./navbar.constants";
import LangToggleButton from "./LangToggleButton";

export default function NavbarLangOnly() {
  const { i18n } = useTranslation();
  const isArabic = i18n.language === "ar";

  return (
    <nav
      className="navbar shadow-sm"
      style={{
        background: COLORS.gradient,
        padding: "10px 0",
        fontFamily: "'Tajawal', 'Cairo', sans-serif",
        direction: isArabic ? "rtl" : "ltr",
        color: COLORS.textLight,
      }}
    >
      <div className="container d-flex justify-content-between align-items-center">
        <a href="/" className="navbar-brand fw-bold">
          <img
            src={isArabic ? logoArabic : logoEnglish}
            alt="Madar Logo"
            style={{
              height: "70px",
              width: "auto",
              objectFit: "contain",
            }}
          />
        </a>

        <LangToggleButton />
      </div>
    </nav>
  );
}
